/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banner_TitleInputs */



/**
* | output |
* | --- |
* | "Tournament banner" |
*
* @param {Banner_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const banner_title = /** @type {((inputs?: Banner_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banner_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bannière du tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Banner del torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Banner do torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Banner del torneo")
	return /** @type {LocalizedString} */ ("Tournament banner")
});